import { ButtonText, ButtonWrapper, ButtonRounded, ButtonFullRounded, LinkButton, TransparentBgButton } from './styles';

const Button = ({ title, wrapperStyle, type, icon, iconProps, onClick, disabled, textStyle, classNames = '', hoverText = '' }) => {
  const childElement = icon ? icon(iconProps) : <ButtonText style={textStyle}>{title}</ButtonText>;

  const buttonProps = {
    style: wrapperStyle,
    onClick,
    disabled,
    className: classNames,
    title: hoverText,
  };

  switch (type) {
    case 'rounded':
      return <ButtonRounded {...buttonProps}>{childElement}</ButtonRounded>;
    case 'linkButton':
      return (
        <LinkButton
          onClick={onClick}
          disabled={disabled}>
          {childElement}
        </LinkButton>
      );
    case 'transparentBackgroundButton':
      return <TransparentBgButton {...buttonProps}>{childElement}</TransparentBgButton>;
    default:
      return (
        <ButtonWrapper
          {...buttonProps}
          type='reset'>
          {childElement}
        </ButtonWrapper>
      );
  }
};

export default Button;
